import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3a514d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-pass-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  class: "img-box",
  style: {"width":"80px"}
}
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, "身份证号", -1))
const _hoisted_9 = { class: "info-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, "施工位置：", -1))
const _hoisted_11 = { class: "info-content van-multi-ellipsis--l2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, "有效期：", -1))
const _hoisted_13 = { class: "info-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvalPassLists, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "uf-pass-item",
        onClick: ($event: any) => (_ctx.showPic(item.pass_pic))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_image, {
              style: {"border":"1px #eee solid","box-sizing":"border-box","border-radius":"4px","margin-bottom":"10px"},
              width: "80px",
              height: "98px",
              fit: "contain",
              src: item.personal_photo
            }, null, 8, ["src"]),
            _createVNode(_component_van_image, {
              style: {"border":"1px #eee solid","box-sizing":"border-box","border-radius":"4px"},
              width: "80px",
              height: "80px",
              fit: "contain",
              src: item.qrcode
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, "姓名：" + _toDisplayString(item.name), 1),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.id_card_number), 1),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.true_place), 1),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(item.dateslot), 1)
          ])
        ])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}